import React from 'react';

export function IllustrationBikeOnPath(props) {
  return (
    <svg {...props} viewBox="0 0 2834 954">
      <defs>
        <linearGradient
          x1="49.939%"
          y1="-55.941%"
          x2="50.252%"
          y2="284.196%"
          id="a"
        >
          <stop stopColor="#9878FE" offset="3%" />
          <stop stopColor="#D9CEFF" offset="38%" />
          <stop stopColor="#DAD0FF" stopOpacity=".96" offset="39%" />
          <stop stopColor="#E1D9FF" stopOpacity=".78" offset="41%" />
          <stop stopColor="#E8E1FF" stopOpacity=".61" offset="44%" />
          <stop stopColor="#EDE8FF" stopOpacity=".47" offset="47%" />
          <stop stopColor="#F2EEFF" stopOpacity=".34" offset="50%" />
          <stop stopColor="#F6F4FF" stopOpacity=".23" offset="54%" />
          <stop stopColor="#F9F8FF" stopOpacity=".15" offset="58%" />
          <stop stopColor="#FCFBFF" stopOpacity=".08" offset="63%" />
          <stop stopColor="#FEFDFF" stopOpacity=".03" offset="69%" />
          <stop stopColor="#FFF" stopOpacity=".01" offset="77%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M2824.59 452.35c-23.89-26-81.56-27.34-108.68-27.87-457-9-763-3.6-1217 5.18-9.28.18-18.567.35-27.86.51-87.1 1.47-1297.78 2.49-1297.78 2.49L0 468.86c14.23 14 66.79 8.94 84.6 9.7 69 2.91 138.19 3.21 207.27 3.42 100.29.3 200.59-.4 300.87-1.37 121.8-1.167 243.593-2.72 365.38-4.66 133.6-2 267.2-4.16 400.8-6.48 135.72-2.28 271.44-4.547 407.16-6.8 239-3.85 478.08 1.32 717 .38 83.9-.33 21.18-.41 105.08 1.14 46.84.87 90 .08 136.45 6.77 19.07 2.74 29.4 12 11.86 26-12.41 9.93-26 12.46-41.36 15.22-28.77 5.17-84.29 4.43-101 32.64-26.6 44.89 69.9 52.34 95.55 58.94 15 3.87 33.5 12.58 32.46 29.05-.88 13.84-15.36 21.17-27.79 24.95-51.43 15.66-102.36 8.6-153.72 28.52-21.67 8.4-61 30.68-60.07 60.82.46 14.36 11.49 25.89 23.31 32.61 40.57 23.1 134.11-3 146.08 63.31 6.45 35.88-40.48 48.09-68.19 54.26-59.82 13.32-118.59 29.94-173.75 56.13 10.48-5 43.75-5.24 56.09-4 13.28 1.39 26.89 2.08 40.06 4.2 13.85 2.24 66.1-13.71 66.16-13.73 36.92-11.27 74.09-22.54 105.81-44.53 19-13.18 38.6-23.48 40-47.3 4-68.81-72.74-67-120.26-79.49-43.9-11.57-22.51-37.89-.31-49.39 32.28-16.72 83.16-21.86 118.22-25.34 27.1-2.7 147.28-21.39 111.53-77.4-15.93-25-56.82-25.4-80.29-37-5.11-2.53-15.53-5.82-15.74-13.53-1.47-56 100.45-34.94 104.28-87.62a33.26 33.26 0 0 0-8.95-25.93z"
          fill="url(#a)"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M704.12 371.21c2.22 3.79 3 9.18 8.52 9.29 4.35.1 8.24-2.89 10.23-6.57 1.53-2.83-2.9-5.15-4.43-2.31-1 1.88-3.56 4.43-6 3.83-2.44-.6-3-5.05-4.1-6.89-1.63-2.78-5.87-.12-4.24 2.65h.02z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M860.74 109.78c16.38 21 50.79 59.91 73.74 73.39 1.39.82 7.94 1.75 8.38 3.3.64 2.24-1.52 4.5-3.82 4.86-2.3.36-4.59-.59-6.71-1.57-31.55-14.54-67.24-41.79-87-70.36 6.73-.73 8.7-8.9 15.43-9.62"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M678 192.58c8.69 26.58 18 86.65 23.4 114.08 1.17 5.95 2.27 11.92 3.37 17.89 2.94 15.95 4.15 30.57 7.09 46.52.82 4.44-2.66-.81-7.08.13-2 .42-43.31-107-53.52-131.45a283.58 283.58 0 0 1-10.36-31c13.17-2.79 23.79-18.15 37.1-16.13"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M711.5 373.76a4.71 4.71 0 0 1-1.89-.66c-1.23-.6-2.91-1.42-4.67-1.05-1.45.33-2 .47-36.08-85.79-8-20.33-15-37.89-18.42-46.17A288 288 0 0 1 640 208.94l-.23-.89.9-.19c5.45-1.16 10.59-4.63 15.56-8 6.82-4.61 13.88-9.38 21.85-8.17l.53.09.17.51c6.39 19.52 13 56.63 18.34 86.45 2 10.95 3.64 20.4 5.09 27.73 1.17 6 2.29 12 3.37 17.9 1.47 8 2.53 15.78 3.55 23.3 1.02 7.52 2.08 15.27 3.54 23.22.18 1 .31 2-.42 2.59a1.24 1.24 0 0 1-.75.28zm-5.64-3.55a10.27 10.27 0 0 1 4.52 1.32l.69.33a5.84 5.84 0 0 0-.09-.63c-1.47-8-2.53-15.78-3.55-23.3-1.02-7.52-2.07-15.27-3.54-23.23-1.08-5.86-2.19-11.92-3.37-17.87-1.45-7.34-3.14-16.8-5.1-27.76-5.26-29.5-11.81-66.15-18.1-85.7-7.09-.83-13.4 3.45-20.08 8-4.85 3.27-9.85 6.64-15.28 8a281.09 281.09 0 0 0 10.09 30c3.48 8.3 10.41 25.87 18.43 46.21 13.44 34 31.72 80.36 34.57 84.64.27-.023.54-.026.81-.01z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M877.71 314.19c1.72 18.78 2.29 41.56 10.23 58.66l-4.32.71c-7.13-6-10.25-15.35-13-24.22-3-9.54-6-19.15-7.19-29.09 2.58.06 11.74-6.12 14.32-6.06"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M856.09 191.59c8.69 26.58 18 86.66 23.4 114.08.47 2.42.94 4.83 1.4 7.25.66 3.54-17.63 10.85-18.95 7.8-13.49-31.13-27.08-68.81-32.59-82a283 283 0 0 1-10.36-31c13.16-2.8 23.79-18.16 37.1-16.14"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M863.87 322.32c-1.46 0-2.38-.42-2.74-1.26-8.73-20.16-17.62-43.35-24.11-60.28-3.65-9.53-6.54-17-8.47-21.68a288 288 0 0 1-10.41-31.1l-.24-.89.91-.19c5.45-1.16 10.59-4.63 15.56-8 6.82-4.61 13.87-9.37 21.85-8.16l.53.08.17.51c6.39 19.53 13 56.64 18.33 86.45 2 11 3.65 20.41 5.1 27.73.47 2.42.94 4.84 1.39 7.26.64 3.34-8.27 7.21-12.69 8.57a18.71 18.71 0 0 1-5.18.96zm-43.8-113.95a281 281 0 0 0 10.09 30.06c2 4.65 4.84 12.18 8.49 21.73 6.49 16.91 15.37 40.08 24.09 60.21.48.6 5 .05 10.92-2.68 5-2.3 6.46-4.13 6.37-4.61-.46-2.41-.92-4.83-1.4-7.24-1.45-7.34-3.14-16.8-5.1-27.76-5.26-29.5-11.81-66.15-18.1-85.69-7.08-.82-13.4 3.44-20.08 8-4.85 3.22-9.85 6.61-15.28 7.98z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M845.19 69.54c0 3.95 1.26 24.84-14 28.42 5.71-.93 10.94 3.09 16.55 4.5 3.18.8 6.55.76 9.66 1.83 3.78 1.31-2.17 3.27 1.81 3-2.83-1.1-.34 1.11-1.12-1.82-3.21-12 8.26-28.68 10-32.27.14-.28-9.47-.31-9.52-.61-.05-.3-.53-.66-.93-.83l-5.87-2.49"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M857.89 30.68c-2.4-1.63-5.77-1.18-8.15.48a15.06 15.06 0 0 0-5 7.05 43.57 43.57 0 0 0-2.63 13.2 37.84 37.84 0 0 0 1.38 14.3c1.51 4.58 4.48 8.8 8.69 11 4.21 2.2 9.73 2.18 13.48-.77 2.7-2.12 4.24-5.43 5.21-8.75a36.92 36.92 0 0 0-3-27.6c-2.43-4.48-6.34-8.72-11.38-9.21"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M845.8 61.69c.38-1-.37-2.45-1.21-3.17-.84-.72-4.25-1.23-5.32 0-2.35 2.66-1.8 5.84.38 7.52a4 4 0 0 0 4.61 0 4.19 4.19 0 0 0 1.54-4.38"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M1002.66 369.13a3.66 3.66 0 0 0 .54-2.75L967.7 189.9a3.64 3.64 0 0 0-3.42-2.93l-38.49-2.16a3.66 3.66 0 0 0-.31 7.31l35.62 2 9.58 47.66h-1.8l-166 2.93h-.49a2.4 2.4 0 0 0-.48.11l-.37.1-.6.12-.52-.34a3.4 3.4 0 0 0-2.06-.59h-1.64a3.59 3.59 0 0 0-1.53 0h-.15l-8.09-.05.41-1.82a3.61 3.61 0 0 0 0-1.6l-11.27-50a3.68 3.68 0 0 0-3.57-2.85h-.06l-28.76.51a3.57 3.57 0 0 0-2.56 1.11 3.62 3.62 0 0 0-1 2.61 3.66 3.66 0 0 0 3.66 3.59h.06l25.78-.46 11 48.87-154.47-.87h-.45a3.38 3.38 0 0 0-.48.11l-.18.05a3.4 3.4 0 0 0-.59.27l-.15.1a4.07 4.07 0 0 0-.38.28l-.17.15a4.623 4.623 0 0 0-.3.33l-.14.17a5.06 5.06 0 0 0-.26.44l-.09.15a3.51 3.51 0 0 0-.21.57l-34 122.39a3.65 3.65 0 0 0 3.52 4.63l169.94-1.1.45.65a7.6 7.6 0 0 0 6.34 3.23 7.5 7.5 0 0 0 6.06-3.23l.45-.64 97.76.77.12 1.5v-1.5a4.14 4.14 0 0 0 .64-.07h.11a2.89 2.89 0 0 0 .55-.18l.72 1.33-.6-1.38a3.22 3.22 0 0 0 .51-.28l.1-.07c.16-.114.311-.24.45-.38l.06-.06.18-.19 97-117L996 367.82a3.65 3.65 0 0 0 3.58 2.94h.06a3.66 3.66 0 0 0 3-1.63h.02zm-405.49-3.51l30.35-109.39L691.07 365l-93.9.62zm35.48-115.1l155.47.95-90.86 109.64-64.61-110.59zm134.63 110.22l-.74.25a7.66 7.66 0 0 0-3.82 2.91l-.44.65-58.69.38 95.09-114.73-31.4 110.54zm8.4 3.82l-.44-.65c-.13-.19-.27-.38-.42-.56l-.5-.61 29.84-105L867 365.28l-91.32-.72zm98.25-1.93L809.29 252 968 249.19l-94.07 113.44z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <g style={{ mixBlendMode: 'multiply' }} fillRule="nonzero">
          <path
            d="M872.89 387.31a19.73 19.73 0 1 1 19.38-20.07c.173 10.887-8.494 19.862-19.38 20.07z"
            fill="#6C12D6"
          />
          <path
            d="M872.54 388.06c-11.01-.102-19.866-9.082-19.815-20.092.051-11.01 8.99-19.907 20-19.907s19.949 8.898 20 19.907c.05 11.01-8.806 19.99-19.815 20.092h-.37zm0-39.45h-.34c-10.659.094-19.237 8.785-19.19 19.444.047 10.66 8.7 19.275 19.36 19.275s19.313-8.616 19.36-19.275c.047-10.659-8.531-19.35-19.19-19.444z"
            fill="#FFF"
          />
        </g>
        <ellipse
          fill="#6C12D6"
          fillRule="nonzero"
          transform="rotate(-1.01 810.204 240.541)"
          cx="810.204"
          cy="240.541"
          rx="23.17"
          ry="6.04"
        />
        <g style={{ mixBlendMode: 'multiply' }} fillRule="nonzero">
          <path
            d="M696.22 385.79a19.73 19.73 0 1 1 19.38-20.07c.184 10.891-8.489 19.873-19.38 20.07z"
            fill="#6C12D6"
          />
          <path
            d="M695.87 386.54c-11.01-.102-19.866-9.082-19.815-20.092.051-11.01 8.99-19.907 20-19.907s19.949 8.898 20 19.907c.05 11.01-8.806 19.99-19.815 20.092h-.37zm.34-1.5a19 19 0 1 0-13.51-5.33 18.84 18.84 0 0 0 13.51 5.29v.04z"
            fill="#FFF"
          />
        </g>
        <ellipse
          fill="#6C12D6"
          fillRule="nonzero"
          transform="rotate(-1.01 635.53 241.03)"
          cx="635.53"
          cy="241.03"
          rx="23.17"
          ry="6.04"
        />
        <path
          d="M691.58 42.09c.3-7.19-8.17-11.51-15.35-11.85-13.11-.63-27.53 7.87-29 20.91-.63 5.69 1.14 11.79-1.22 17-6 13.3-30.82 7.24-36.67 20.62-1.84 4.21-1 9-1.22 13.62-.22 4.62-2.32 9.87-6.81 10.8-4.49.93-8.63-3-13.19-3-6.73 0-10.32 8.25-10.07 15A33.17 33.17 0 0 0 592 150.71c6.69 4.68 15.85 6.63 23.14 2.95 13.61-6.88 14-28.43 27.6-35.4 7.6-3.91 19.32-3.63 21.45-11.91 1.51-5.88-3.58-12.67-.36-17.81 2-3.21 6.28-4 9.38-6.15 7.51-5.27 6.33-16.79 11-24.71 2.07-3.55 5.31-6.36 7-10.11 1.69-3.75.83-9.21-3.08-10.44"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M687.38 121.21c16.39 21 37 47.69 60 61.18 1.39.81 7.83 3.4 8.27 5 .64 2.24-.52 3.5-2.82 3.86-2.3.36-4.59-.6-6.71-1.57a196.68 196.68 0 0 1-78.87-66.24l20.18-2.18M668.06 66.3c0 4 4.54 25.4-17 31.65 5.71-.94 12.94 4.09 18.55 5.5 3.18.8 6.55.76 9.66 1.83 3.78 1.3.65 4.37 4.64 4-2.83-1.1 2.71-4.62.28-6.42-13.52-10 2.3-24.13 4.09-27.72.13-.28-7.73-1.35-7.79-1.65-.06-.3-.53-.66-.93-.83l-5.87-2.5"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M676.32 32c-2.52-1.08-5.57-.06-7.47 1.92a14.1 14.1 0 0 0-3.34 7.42 41.48 41.48 0 0 0-.07 12.73 35.9 35.9 0 0 0 3.87 13 18 18 0 0 0 10.05 8.67c4.31 1.31 6.41 2.27 9.36-1.14 2.12-2.46 6-7.8 6.25-11.06a34.9 34.9 0 0 0-7.72-25.07c-3.07-3.72-7.46-6.95-12.22-6.49"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M685.23 31.39a18.54 18.54 0 0 0-8.46-3.8C667.12 26 657.42 31.77 656 41.74c-.82 5.56.88 11.26 3.7 16.12a70.28 70.28 0 0 0 4.22 6.68 7.3 7.3 0 0 1 4.85-2 9.37 9.37 0 0 1 .95-3.45c1.86-3.71 5.2-6.47 8.73-8.66 5-3.09 16.64-2.57 16.64-2.57s-3.31-8.37-4.87-10.92a21.23 21.23 0 0 0-4.99-5.55z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M670.69 63a3.13 3.13 0 0 0-1.69-2.77c-.9-.51-4.17-.37-4.94 1-1.7 2.9-.62 5.74 1.71 6.91a3.76 3.76 0 0 0 4.29-.79 4 4 0 0 0 .63-4.35"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M676.93 56.87c-.74.41-2.41 1.55-2 3.19a.66.66 0 0 0 .66.51h.16a.55.55 0 0 0 .43-.69c-.18-.81.7-1.56 1.59-2a2.29 2.29 0 0 1 2.57.18.55.55 0 0 0 .57.11.7.7 0 0 0 .42-.53.59.59 0 0 0-.23-.59 3.56 3.56 0 0 0-4.17-.18zm15.92-3.32a3.28 3.28 0 0 0-3.62-1.18 3.24 3.24 0 0 0-2.32 3 .61.61 0 0 0 .27.57.72.72 0 0 0 .4.12.59.59 0 0 0 .59-.55 2.06 2.06 0 0 1 1.45-1.9 2 2 0 0 1 2.23.76.6.6 0 0 0 .87.1.61.61 0 0 0 .13-.92zM685.16 55a.62.62 0 0 0-.8-.41.61.61 0 0 0-.42.77 33.71 33.71 0 0 0 1.48 4.16 13.29 13.29 0 0 0 1.08 2c.08.11.14.2.2.27.19.26.23.31.08.72-.15.41-.2.39-.44.52l-.26.14a.56.56 0 0 0-.31.51.71.71 0 0 0 .35.59.6.6 0 0 0 .62-.01l.18-.11c.7-.4 1.3-.74 1.45-1.31a1.69 1.69 0 0 0-.29-1.3 30.49 30.49 0 0 1-2.92-6.54z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M618.86 206.46c-2.27 6.91-3.34 10.32-3.23 17.59.4 25.52 72.06 24.6 74.07 47.74 2.33 26.79-7.91 60.91-10 87.72-.25 3.23-2.15 4.58 1 5.52 3.15.94 4.31-2.46 5.88-5.46a461.32 461.32 0 0 0 23.29-50.82c6.84-18.12 13.39-37.6 5.68-56.6-9.6-23.62-57.28-49.8-57.09-55.45"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M681.78 366.09a4.75 4.75 0 0 1-1.37-.22c-3-.9-2.48-2.6-2-4.1.236-.759.397-1.54.48-2.33.79-10.2 2.71-21.22 4.75-32.9 3.28-18.76 6.67-38.15 5.24-54.67-.93-10.64-18.44-16.26-35.38-21.69-18.92-6.07-38.48-12.34-38.7-26.11-.11-7.55 1.09-11.22 3.28-17.89l1.66.55c-2.2 6.7-3.3 10.06-3.19 17.31.2 12.52 19.15 18.6 37.48 24.48 18.33 5.88 35.56 11.4 36.59 23.2 1.46 16.75-2 36.26-5.25 55.12-2 11.64-4 22.62-4.74 32.74a12.88 12.88 0 0 1-.54 2.67c-.43 1.52-.44 1.54.88 1.95 1.87.56 2.71-.7 4.19-3.71.22-.45.43-.89.66-1.33A453.71 453.71 0 0 0 709 308.44c7.22-19.1 13.08-37.76 5.69-56-5.93-14.59-26.5-30.09-41.51-41.4-10.63-8-15.73-12-15.65-14.41l1.75.06c0 1.65 7.57 7.4 15 13 15.18 11.44 36 27.1 42.08 42.14 7.63 18.79 1.67 37.8-5.67 57.24A456.37 456.37 0 0 1 687.32 360c-.22.43-.43.86-.64 1.29-1.12 2.25-2.36 4.8-4.9 4.8z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M680 95.91a7.64 7.64 0 0 1 .1-3.68 2 2 0 0 0-1.57-2.37l-2.17-.39a26.84 26.84 0 0 1-9.87-3.73c-.29-.19-.57-.39-.84-.59a2 2 0 0 0-2.73.3c-9.74 12-28.82 21.5-38.53 56-9.91 31.16-9.47 64.86-8.33 65 27.26 3.41 42.46 12.67 69.81 9.49-4.87-20.28 6.59-60.9 5.66-84.92l.22-.31c1.28-7.55-1.91-23.4-7.31-28.83-1.74-1.75-3.79-3.52-4.44-5.97z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M648.3 137.05c11.77 14.9 24.2 29.5 39.24 41.07 15.04 11.57 46.81 20.52 65.76 21.65 2.76.17 6.38-.49 6.79-3.22.36-2.38-12.31-3.25-14.42-4.4-16.32-8.88-35.82-17.34-50.26-30.43-13.62-12.35-22.36-29.14-31.83-43.89l-15.28 19.22z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M869.92 68.77a7.93 7.93 0 0 0-4-3.14c-2.13-.7-6-1-7.87.23a10 10 0 0 0-4.14 6c-1-.4-1.96-.892-2.87-1.47-9-5.84-2.43-19.92-2.43-19.92 2-2.09 8.5-3.46 11.35-3.23 7.34.59 10.71 1.76 12.45 4.57 1-3 2.07-14.44 1.68-20a9.93 9.93 0 0 0-7.67-9c-5.76-1.3-12.24-.89-17.75.09a10 10 0 0 0-8.09 11.43c.23 1.43.41 7 .65 8.71.9 6.75-.32 12.5.58 19.24.63 4.67 1 12 2.95 16.29 2.14 4.79 5.18 7.57 15 8.25a12.53 12.53 0 0 0 5.56-.8 12.26 12.26 0 0 0 5.37-18.32 11.26 11.26 0 0 1-.77 1.07zm-13.59 3.91c.84-1.76 4.67-6 9.78-2.67.452.31.8.75 1 1.26a13.45 13.45 0 0 1-10.78 1.41z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <g
          style={{ mixBlendMode: 'multiply' }}
          fill="#6C12D6"
          fillRule="nonzero"
        >
          <path d="M854.48 59a3 3 0 0 1 5.22.47c.26.59 1.24.31 1-.29a4 4 0 0 0-7.08-.67c-.37.54.52 1 .89.49h-.03z" />
          <path d="M860.21 60a.66.66 0 0 1-.63-.4 2.82 2.82 0 0 0-2.34-1.72 2.86 2.86 0 0 0-2.65 1.27.67.67 0 0 1-1 .16.54.54 0 0 1-.15-.79 4.12 4.12 0 0 1 3.84-1.89 4.21 4.21 0 0 1 3.46 2.58.52.52 0 0 1-.29.73.72.72 0 0 1-.24.06zM857 57.57h.29a3.06 3.06 0 0 1 2.55 1.87.44.44 0 0 0 .59.21.28.28 0 0 0 .16-.4 3.87 3.87 0 0 0-6.87-.65.31.31 0 0 0 .09.45.42.42 0 0 0 .6-.1 3.12 3.12 0 0 1 2.59-1.38z" />
        </g>
        <g
          style={{ mixBlendMode: 'multiply' }}
          fill="#6C12D6"
          fillRule="nonzero"
        >
          <path d="M865 59.25c.78-2 4.82-2.61 5 .12a.51.51 0 0 0 1 0c-.19-3.94-5.79-3.45-7-.34-.23.61.77.86 1 .25v-.03z" />
          <path d="M870.49 60a.62.62 0 0 1-.64-.6 1.69 1.69 0 0 0-1.54-1.7 3.06 3.06 0 0 0-3.17 1.62.67.67 0 0 1-.89.39.54.54 0 0 1-.33-.73 4.31 4.31 0 0 1 4.63-2.5 2.9 2.9 0 0 1 2.57 2.89.57.57 0 0 1-.26.53.69.69 0 0 1-.37.1zm-2.59-2.58c.15-.01.3-.01.45 0a1.94 1.94 0 0 1 1.75 1.94c0 .13.074.25.19.31a.44.44 0 0 0 .43 0 .33.33 0 0 0 .15-.31 2.63 2.63 0 0 0-2.36-2.65 4.14 4.14 0 0 0-4.36 2.29.3.3 0 0 0 .19.41.45.45 0 0 0 .57-.24 3.21 3.21 0 0 1 2.99-1.78v.03z" />
        </g>
        <path
          d="M684.42 68.87a5.53 5.53 0 0 0 5.75-1.9c.78-1-.62-2.43-1.41-1.42a3.6 3.6 0 0 1-3.76 1.39 1 1 0 0 0-.53 1.93h-.05z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <g style={{ mixBlendMode: 'multiply' }} fillRule="nonzero">
          <path
            d="M593.77 449.75c-32.54.586-62.23-18.49-75.22-48.332-12.991-29.841-6.725-64.57 15.876-87.988 22.601-23.42 57.085-30.916 87.369-18.995 30.284 11.922 50.403 40.914 50.975 73.455.73 44.397-34.605 81.012-79 81.86z"
            fill="#FFF"
          />
          <path
            d="M592.33 453.26c-46.128-.413-83.246-38.033-83.04-84.162.207-46.129 37.66-83.415 83.79-83.415 46.13 0 83.583 37.286 83.79 83.415.206 46.13-36.912 83.75-83.04 84.162h-1.5zm0-160.91H591c-41.438 1.81-73.997 36.116-73.639 77.592.359 41.476 33.506 75.215 74.969 76.308h1.38c41.439-1.811 73.996-36.12 73.635-77.597-.361-41.476-33.511-75.214-74.975-76.303h-.04z"
            fill="#6C12D6"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }} fillRule="nonzero">
          <path
            d="M1001 447.55c-32.54.586-62.23-18.49-75.22-48.332-12.991-29.841-6.725-64.57 15.876-87.988 22.601-23.42 57.085-30.916 87.369-18.995 30.284 11.922 50.403 40.914 50.975 73.455.73 44.397-34.605 81.012-79 81.86z"
            fill="#FFF"
          />
          <path
            d="M999.58 451.06c-46.43-.416-83.792-38.282-83.584-84.714.208-46.432 37.907-83.963 84.339-83.963s84.131 37.531 84.34 83.963c.207 46.432-37.155 84.298-83.585 84.714h-1.51zm.06-160.91h-1.38c-41.438 1.81-73.997 36.116-73.639 77.592.359 41.476 33.506 75.215 74.969 76.308h1.41c41.438-1.81 73.997-36.116 73.639-77.592-.359-41.476-33.506-75.215-74.969-76.308h-.03z"
            fill="#6C12D6"
          />
        </g>
        <g
          style={{ mixBlendMode: 'multiply' }}
          transform="translate(988 356)"
          fill="#6C12D6"
          fillRule="nonzero"
        >
          <circle
            transform="rotate(-14.29 11.602 11.128)"
            cx="11.602"
            cy="11.128"
            r="9.08"
          />
          <path d="M11.61 20.68a9.58 9.58 0 0 1-.17-19.15h.17a9.58 9.58 0 0 1 .17 19.15h-.17zm0-18.15h-.15a8.66 8.66 0 1 0 .15 0z" />
        </g>
        <g
          style={{ mixBlendMode: 'multiply' }}
          transform="translate(581 358)"
          fill="#6C12D6"
          fillRule="nonzero"
        >
          <circle
            transform="rotate(-14.29 11.36 11.855)"
            cx="11.359"
            cy="11.855"
            r="9.08"
          />
          <path d="M11.36 21.41a9.58 9.58 0 0 1-.16-19.15h.17a9.57 9.57 0 0 1 6.88 16.23 9.47 9.47 0 0 1-6.72 2.92h-.17zm0-18.15h-.16a8.57 8.57 0 1 0 8.73 8.43 8.58 8.58 0 0 0-8.56-8.43h-.01z" />
        </g>
        <path
          d="M647.66 137.39c-6.51-5.52-12.93-24-5.41-31.34 4.86-4.74 13.28-.77 17.28 3.13 2.25 2.19 3.56 5 5.43 7.45-3.65 2.75-16.23 20.5-17.3 20.76z"
          fill="#C7BDFF"
          fillRule="nonzero"
        />
        <path
          d="M928.52 187.56c1.82.08 3.64 0 5.45.08 2.66.18 2 1.64 3.86 3 .79.6 1.79.93 2.61 1.51 2.15 1.53 1.11 2.16-1.25 2.3a42.24 42.24 0 0 1-10.06-.43l-3.23-4.68 2.62-1.78z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M501.75 451c-.47-7.84 66.75-5 74.18-5 14.65 0 30.51-.25 45.63.23 9.5.3 36.87-5.42 43.42 5.94-.4 1.07-1 1.63-1.72 1.69-3.07 1.85-8.82 1.76-12.32 2.08-6.24.57-12.52.83-18.79 1-39.54 1.22-79.27.89-118.74-2.89a48.13 48.13 0 0 1-7.76-1.17c-.96-.25-3.82-.66-3.9-1.88zm583.12 1.54c.35 9.34-148.32 3-155.14 1.8-2.28-.41-4.81-1.11-5.93-3.15s34.62-5.88 37.71-6.06c37.2-2.17 74.76-.05 111.75 4.15a48.07 48.07 0 0 1 7.75 1.31c.99.27 3.8.72 3.86 1.95z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M194.66 185.72c33.41-41.14 79.52-74.27 133.22-80.73 35.76-4.3 110.24-.11 93.81 54.34-3.07 10.19-11.72 17.73-20.92 23.13C390.85 188.27 368 207 356 197.61c-16.48-12.93 4.71-24.62 15.69-27.7 28.74-8.08 59.26-3 88.11 1.66 22.59 3.61 75.24 17.75 95.85 4.15"
          stroke="#9973FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="9"
        />
        <path
          d="M677.59 366.3c-.14 4.39-2.31 9.39 2.28 12.4 3.63 2.39 8.52 1.93 12.16-.13 2.8-1.59.28-5.91-2.53-4.32-1.86 1.06-5.37 1.87-7.1.07-1.73-1.8.12-5.89.19-8 .1-3.21-4.91-3.21-5 0v-.02z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M856.1 362.51c-.13 4.39-2.3 9.38 2.29 12.4 3.63 2.38 8.51 1.93 12.15-.14 2.8-1.58.28-5.91-2.52-4.31-1.87 1.05-5.37 1.86-7.11.07-1.74-1.79.13-5.89.19-8 .1-3.22-4.9-3.22-5 0v-.02zm22.65 8.04c1.6 4.09 1.56 9.54 7 10.52 4.28.77 8.59-1.57 11.13-4.89 2-2.56-2.05-5.55-4-3-1.3 1.7-4.21 3.82-6.51 2.85-2.3-.97-2.19-5.47-3-7.46-1.17-3-5.77-1-4.6 2l-.02-.02z"
          fill="#491E4F"
          fillRule="nonzero"
        />
        <path
          d="M1284.4 217.8c-2-3-5.37-5-8.89-4.52-3.52.48-6.87 3.51-10.48 2.89-5-.86-6.19-8.18-3.38-12.43 2.81-4.25 7.76-6.44 11.95-9.36 6.38-4.45 11.48-11.82 10.58-19.55-.9-7.73-9.92-14.21-16.81-10.58-3.44 1.81-6 5.68-9.84 5.95-4.16.29-7.4-4-7.74-8.21-.34-4.21 1.3-8.19 2.42-12.21 2.37-8.6 2.2-18.42-2.89-25.75-15.38-22.12-38.7 3.16-34.46 22.61 1.06 4.84 3.4 9.52 3.15 14.48-.25 4.96-4.78 10.23-9.49 8.66-2.11-.7-3.59-2.55-5.36-3.89-7.82-5.95-21.3 1.46-20.48 11.24.92 11 14.15 15.71 21.36 24 4 4.63 4.65 13.94-1.38 15-3.2.59-6.16-1.79-9.36-2.39-5.85-1.1-11.41 4.3-12.32 10.18-.91 5.88 1.68 11.75 5 16.69a56.86 56.86 0 0 0 96.7-3.56c2.55-4.51 4.53-9.69 3.62-14.79a11.93 11.93 0 0 0-1.9-4.46z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <g
          style={{ mixBlendMode: 'multiply' }}
          transform="translate(1204 149)"
          fill="#491E4F"
          fillRule="nonzero"
          stroke="#491E4F"
        >
          <rect x="29.1" y=".1" width="1.44" height="188.72" rx=".72" />
          <path d="M30 62.24a.71.71 0 0 1 0-1l28-25.58a.7.7 0 0 1 1 0 .72.72 0 0 1 0 1L31 62.24a.7.7 0 0 1-1 0z" />
          <rect
            transform="rotate(-42.41 42.192 93.141)"
            x="25.607"
            y="92.426"
            width="33.17"
            height="1.43"
            rx=".715"
          />
          <path d="M29.65 62.24a.71.71 0 0 0 0-1l-28-25.58a.7.7 0 0 0-1 0 .72.72 0 0 0 .05 1l28 25.58a.71.71 0 0 0 .95 0z" />
          <rect
            transform="rotate(-47.6 17.4 93.183)"
            x="16.684"
            y="76.598"
            width="1.43"
            height="33.17"
            rx=".715"
          />
        </g>
        <path
          d="M1383.72 138.19c-2.25-4.44-6-7.75-11-8.18-5.87-.51-13.53 2.46-16.6-2.58-2.14-3.52.3-8 2.77-11.28 6-8.05 12.83-15.7 17.07-24.83 4.24-9.13 5.61-20.31.6-29a8.9 8.9 0 0 0-3.08-3.44c-9-5.2-15.81 16.77-25.48 13-3.93-1.53-5-6.54-5-10.76 0-9.21 2.19-18.29 2.77-27.48.58-9.19-.77-19.13-6.89-26-16.18-18.21-37.91 3.78-38.11 21.71-.11 9.79 2.79 19.36 3.79 29.1.35 3.45.43 7.13-1.24 10.18s-5.63 5.09-8.74 3.53c-2.51-1.26-3.56-4.22-5.27-6.45-14.14-18.47-34.22 14-17.48 31.43 4.07 4.22 9.1 7.49 12.83 12a28.82 28.82 0 0 1 6.26 21.58c-8.48-1.49-18.36-2.2-24.52 3.82-4.37 4.27-5.57 10.95-4.85 17 1.52 12.95 10.65 24.17 22 30.62 11.35 6.45 24.61 8.69 37.65 9.08 13.45.4 27.25-1.12 39.36-7s22.31-16.65 25.18-29.8a25.28 25.28 0 0 0-2.02-16.25z"
          stroke="#00E7E3"
          strokeWidth="1.5"
          fill="#FFF"
          fillRule="nonzero"
          style={{ mixBlendMode: 'multiply' }}
        />
        <g
          style={{ mixBlendMode: 'multiply' }}
          transform="translate(1291 42)"
          fill="#491E4F"
          fillRule="nonzero"
          stroke="#491E4F"
        >
          <rect x="32.15" y=".6" width="1.56" height="315.22" rx=".72" />
          <path d="M33.15 68.36l-.09-.09a.72.72 0 0 1 0-1l30.62-28a.71.71 0 0 1 1 0l.09.1a.7.7 0 0 1 0 1l-30.62 28a.7.7 0 0 1-1-.01z" />
          <rect
            transform="rotate(-42.37 46.52 118.72)"
            x="28.446"
            y="117.94"
            width="36.15"
            height="1.56"
            rx=".72"
          />
          <path d="M32.7 68.36l.09-.09a.71.71 0 0 0 0-1l-30.62-28a.73.73 0 0 0-1 0l-.09.1a.72.72 0 0 0 0 1l30.62 28a.7.7 0 0 0 1-.01z" />
          <rect
            transform="rotate(-47.62 19.378 118.605)"
            x="18.598"
            y="100.53"
            width="1.56"
            height="36.15"
            rx=".72"
          />
        </g>
        <path
          d="M1262 334.85c.17 7.83-22 5.52-24.48 5.57-4.84.11-10.08.47-15.07.1-3.14-.23-12.17 5.69-14.36-5.62.13-1.07.32-1.64.57-1.7 1-1.87 2.9-1.83 4.06-2.17a35.4 35.4 0 0 1 6.2-1.16c13.06-1.51 26.18-1.47 39.22 2a6.73 6.73 0 0 1 2.57 1.12 2.19 2.19 0 0 1 1.29 1.86zm88.1 25.71c.18 7.84-22 5.52-24.48 5.58-4.84.11-10.08.46-15.07.1-3.14-.23-12.17 5.69-14.36-5.63.13-1.07.32-1.64.57-1.7 1-1.87 2.9-1.82 4.06-2.17a36.35 36.35 0 0 1 6.2-1.16c13.06-1.51 26.18-1.46 39.22 2a6.7 6.7 0 0 1 2.57 1.11 2.2 2.2 0 0 1 1.29 1.87z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M861.93 362c8.3-15.47 17.8-33 22.58-49.9a1.8 1.8 0 0 0-1.45-2.68 74.94 74.94 0 0 0-13.27-3.42c-5.21 17.51-12.32 36.46-14.5 54.6 1.46-.23 5.24.91 6.64 1.39"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M797 205.47c-2.27 6.91 5.43 9.3 5.55 16.57.4 25.53 63.28 25.63 65.29 48.77.94 10.82-.88 22.76-2 35.1-.2 2.32 20.83 5.17 20.83 5.17 1.24.17 7.05-19.91 7.65-22.17 2.21-8.45 3.43-17.25 2.26-26-1.77-13.28-8.87-22.87-18.26-31.89-8.53-8.2-18.05-15.28-27.47-22.4-2.81-2.13-14.46-8.61-14.31-12.94"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M886.82 312h-.26c-21.87-3-21.67-5.26-21.59-6.11.24-2.8.53-5.57.81-8.31 1-9.44 1.88-18.35 1.16-26.65-.93-10.66-15.62-16.25-31.18-22.17-16.67-6.34-33.9-12.9-34.12-26.65 0-3.05-1.58-5.21-3.06-7.31-1.87-2.64-3.81-5.38-2.44-9.55l1.66.54c-1.09 3.34.44 5.5 2.21 8 1.56 2.2 3.33 4.7 3.38 8.29.2 12.57 16.87 18.91 33 25.05 16.13 6.14 31.28 11.9 32.3 23.65.73 8.46-.19 17.46-1.16 27-.27 2.67-.55 5.38-.79 8.1 1.14 1.07 9.62 2.95 19.67 4.35 1.46-2.28 6.12-17.83 7.07-21.47 2.53-9.65 3.26-18 2.25-25.63-1.91-14.23-10.17-23.84-18-31.37-8-7.69-17-14.51-25.76-21.11l-1.63-1.22c-.55-.42-1.49-1-2.59-1.76-6.17-4-12.19-8.27-12.07-11.91l1.75.06c-.1 3 7.58 8 11.28 10.39 1.17.76 2.09 1.37 2.69 1.82l1.62 1.23c8.78 6.62 17.85 13.47 25.92 21.24 8.07 7.77 16.56 17.64 18.53 32.4 1 7.83.3 16.43-2.29 26.3-.27 1-1.87 6.65-3.59 12-3.16 9.8-4 10.8-4.77 10.8z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M802.65 146.56c11.1-43.56 40.15-59.69 40.15-59.69 1.06 9.94 15.38 9.76 15.38 9.76.61 2.69 3.07 9.18 3.85 11.71 9.28 30.26-3 88.1 1.94 110.37-27.32 1.16-38.8 17-66.13 17.85-1.15.04-5.05-55.81 4.81-90z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M928.38 187.79c-10-5-47.63-18.3-55.83-26.07-12.61-11.94-21.48-30.26-30.87-44.87l-15.27 19.22c11.77 14.89 24.2 29.49 39.24 41.07 9.53 7.33 52.24 13.35 63.62 17.12 1.32-4.46-.95-6.18-.89-6.47z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M864.41 177.57A92.08 92.08 0 0 1 826 137.28l.9-.43a91 91 0 0 0 38 39.85l-.49.87zm-11.29-39.856l.788-.616 12.808 16.364-.788.616z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components-legacy/SVG/IllustrationBikeOnPath.js